import React from 'react';
import { Button } from '@optic-delight/ui-framework';
import { FallbackProps } from '@optic-delight/benefitsolver-services/build/types/components/error-boundary/ErrorBoundary';

export function AppFallback({ error, resetErrorBoundary }: FallbackProps) {
	return (
		<div role="alert">
			<p>Something went wrong:</p>
			{process.env.NODE_ENV !== 'production' && <pre>{error.message}</pre>}
			<Button onClick={resetErrorBoundary}>Try again</Button>
		</div>
	);
}
